import { api } from "./client";

export type GeocodeResult = {
	id: string;
	label: string;
	center: [number, number];
	bbox: [number, number, number, number] | null;
};

export const geocodeApi = {
	search: (q: string) =>
		api.get<{ results: GeocodeResult[] }>(`/geocode?q=${encodeURIComponent(q)}`),
};
